export const MAKE = 'make'
export const MODEL = 'model'
export const MANUFACTURER = 'manufacturer'
